import { TAiPageChatMessageDto } from '@app-velocity/av-api-v2';
import { getSystemResponseDescription } from '@app-velocity/common';

import { Alert } from '../Alert';

export type AiResponseSystemMessageProps = {
  message: TAiPageChatMessageDto;
};

export const AiResponseSystemMessage = ({
  message,
}: AiResponseSystemMessageProps) => {
  const { systemResponse } = message;

  if (!systemResponse) return null;

  const { type } = systemResponse;
  const description = getSystemResponseDescription(systemResponse);

  if (!description) return null;

  switch (type) {
    case 'ACTION_FOUND':
    case 'DELAYED_ACTION_FOUND':
      return <Alert size="compact" severity="info" message={description} />;
    case 'NO_SUITABLE_ACTION_FOUND':
    case 'NO_AVAILABLE_ACTION':
    case 'WAITING_PERIOD_TOO_LONG':
      return <Alert size="compact" severity="warning" message={description} />;
    default:
      return null;
  }
};
